import React, { Component } from 'react';
import Dropdown from 'react-dropdown';
import ConditionedComponent from 'components/ConditionedComponent.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import {setContextualHelp} from "actions/index.js";
import {PARAMETERIZER_FACTOR} from 'constants/contextual-help.js';
import {PARAMETERIZER_OFFSET} from 'constants/contextual-help.js';
import {PARAMETERIZER_DROPDOWN} from 'constants/contextual-help.js';
import {PROBABILITY} from 'constants/contextual-help.js';
import { connect } from "react-redux";

class LimitEffectComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.props.effect.isEnabled();
    }

    setContextualHelp(e, contextualHelp) {
        e.stopPropagation();
        this.props.setContextualHelp(contextualHelp);
    }

    render() {
        return (
            <div>
              <ConditionedComponent condition={this.isEnabled()}>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  contextualHelp={PARAMETERIZER_FACTOR}
                  name={'Limit'}
                  parameter={this.props.effect.limitParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={1}
                  min={1}
                  max={16}/>
            </ConditionedComponent>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
}
 
export default connect(null, mapDispatchToProps)(LimitEffectComponent);
